export default __webpack_public_path__ + "static/media/logo_white.3e1b9ceb.png";